<app-event-nav></app-event-nav>
<app-event-header></app-event-header>
<app-signup></app-signup>
<app-event-about></app-event-about>
<app-event-blog></app-event-blog>
<app-event-contact></app-event-contact>
<app-event-copyright></app-event-copyright>